/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 640) return;

  document.querySelectorAll('[data-section-type="background-video"]').forEach(function (section) {
    var settings;

    try {
      settings = JSON.parse(section.getAttribute('data-section-settings'));
    } catch (e) {
      return;
    }

    if (!settings.mobileVideoId) return;

    var desktopHolder = section.querySelector('.ImageHero__VideoHolder');
    var mobileHolder = section.querySelector('.ImageHero__MobileVideoHolder');

    if (!mobileHolder) return;

    if (desktopHolder) {
      desktopHolder.style.display = 'none';
      desktopHolder.innerHTML = '';
    }

    if (settings.mobileVideoType === 'vimeo') {
      mobileHolder.innerHTML =
        '<iframe src="https://player.vimeo.com/video/' +
        settings.mobileVideoId +
        '?autoplay=1&muted=1&loop=1&background=1" ' +
        'frameborder="0" allow="autoplay; fullscreen" ' +
        'style="position:absolute;top:50%;left:50%;width:177.78vh;height:56.25vw;min-width:100%;min-height:100%;transform:translate(-50%,-50%);"></iframe>';
    }

    if (settings.mobileVideoType === 'youtube') {
      mobileHolder.innerHTML =
        '<iframe src="https://www.youtube.com/embed/' +
        settings.mobileVideoId +
        '?autoplay=1&mute=1&loop=1&playlist=' +
        settings.mobileVideoId +
        '&controls=0" frameborder="0" allow="autoplay" ' +
        'style="position:absolute;top:50%;left:50%;width:177.78vh;height:56.25vw;min-width:100%;min-height:100%;transform:translate(-50%,-50%);"></iframe>';
    }
  });
});